import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";
import { useState } from "react";
import { useSelector } from "react-redux";

const dataFormatter = new Jsona();

const adminSettingsApiService = async settingsType =>
  new JsonApiService(settingsType, {
    baseUrl: `${visionURL}/admin_console/api/settings`,
    credentials: "include"
  });

export const useAdminSettings = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const id = "current";

  const getSettings = async settingsType => {
    setIsLoading(true);
    const service = await adminSettingsApiService(settingsType);
    const response = await service.find(id).then(response => response.json());
    setIsLoading(false);
    return dataFormatter.deserialize(response);
  };

  const updateSettings = async (settingsType, settingsData) => {
    setIsSaving(true);
    const service = await adminSettingsApiService(settingsType);
    const response = await service
      .update(
        id,
        visionCallService.serializeRequestBody(settingsData, settingsType)
      )
      .then(response => response.json())
      .catch(error => error);
    setIsSaving(false);
    if (response.errors || response.error) {
      return { errors: response.errors || response.error };
    }
    return dataFormatter.deserialize(response);
  };

  const getRolesPermissions = () => getSettings("roles_permissions");

  const updateRolesPermissions = settingsData =>
    updateSettings("roles_permissions", settingsData);

  const getGlobalAssignment = () => getSettings("global_assignment");

  const updateGlobalAssignment = settingsData =>
    updateSettings("global_assignment", settingsData);

  const getPolicySettings = () => getSettings("policy");
  const { policyLogoImage } = useSelector(
    ({ learningCenterSettingsState }) => ({
      policyLogoImage: learningCenterSettingsState.policyLogoImage
    })
  );

  const updatePolicySettings = settingsData =>
    updateSettings("policy", settingsData);

  return {
    isLoading,
    isSaving,
    getRolesPermissions,
    updateRolesPermissions,
    getGlobalAssignment,
    updateGlobalAssignment,
    getPolicySettings,
    updatePolicySettings,
    policyLogoImage
  };
};
